import * as R from 'ramda';
import { isBlank } from '@trs/utils';

export const filterEmpty = list => R.reject(isBlank, list);

export default {
  filterEmpty,
};
